/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class GmaoUserController {
    /** @ngInject */
    constructor($log, authenticationService) {
        this.$log = $log;
        this.authenticationService = authenticationService;
        this.$log.debug('Controller \'GmaoUser\' loaded');
    }

    $onInit() {
        this.user = this.authenticationService.getAuthenticatedUser();
    }
}

export const gmaoUserComponent = {
    template: require('./gmao-user.html'),
    controller: GmaoUserController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoUser.js